(function($) {

  const RatingThreshold = 4.5;
  const LowPriceLength = 2;
  const infusions = ['korova', 'raki', 'magadan', 'kiska', 'fakultet', 'shuba', 'nakatilnya', 'lunapark', 'eliksir', 'bufet', 'larisa-2'];
  const cocktails = ['bruklin', 'ugol', 'mao', 'luch', 'boho', 'tangiers', 'nakatilnya', 'rukivverh', 'euphoria', 'empire', 'shanghai', 'mojo']
  const beer = ['harats', 'legenda84', 'sobranie', 'biblioteka', 'london', 'korova', 'kvadryupel', 'schneider', 'goblin', 'nevinnost']

  let map;
  let markersGroup;
  let items = [];

  function createIcon(src) {
    return src ? L.icon({
      iconUrl: src,
      iconSize: [40, 40],
      iconAnchor: [20, 40],
      popupAnchor: [0, -40]
    }) : new L.Icon.Default({
        iconAnchor: [-2, 70]
    });
  }

  function statusLabel(hours) {
    if (!hours || hours.length === 0) {
      return '';
    }
    const info = window.mypubs.getBarStatus(hours);
    return info.isClosingSoon ? 'Скоро закроется' : info.isOpen ? 'Открыто сейчас' : 'Закрыто';
  }

  function ratingLabel(rating) {
    const value = parseFloat(rating.attr('value'));
    if (isNaN(value) || value < 0) {
      return 'Нет оценок';
    }
    return `${window.mypubs.stars(value)} ${value.toFixed(1)}`;
  }

  function buildPopup(item, title, url) {
    return `<h6>${title}</h6><div class="map-popup-status">${statusLabel(item.hours)}</div>` +
      `<div class="map-popup-rating">${ratingLabel(item.rating)}</div>` +
      `<a class="map-popup-link" href="${url}">Подробнее</a>`;
  }

  function collectItems() {
    const list = [];
    $('#map-data .pub-marker').each(function() {
      const item = $(this);
      const location = item.find('.pub-location').val();
      if (!location) {
        return;
      }
      const [lat, lng] = location.split(',').map(Number);
      const icon = item.find('.pub-marker-icon').data('src');
      const title = item.find('.bar-title a').text();
      const url = item.find('.bar-title a').attr('href');
      const hours = item.find('.bar-hours');
      const rating = item.find('.bar-rating');
      const entry = {
        recommended: item.data('recommended') === true,
        priceLength: parseInt(item.data('price-length'), 10),
        hours,
        rating,
        url
      };
      const marker = L.marker([lat, lng], {
        icon: createIcon(icon)
      }).bindTooltip(`<a href="${url}">${title}</a>`, {
        permanent: true,
        direction: 'bottom',
        className: 'map-marker-label',
        offset: [0, 2],
        interactive: true
      }).bindPopup(() => buildPopup(entry, title, url), {
        className: 'map-popup-box'
      });
      marker.on('tooltipopen', event => {
        $(event.tooltip.getElement()).find('a').on('click', clickEvent => {
          clickEvent.preventDefault();
          marker.openPopup();
        });
      });
      entry.marker = marker;
      list.push(entry);
    });
    return list;
  }

  function initMap() {
    map = L.map('map');
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OSM',
    }).addTo(map);
    markersGroup = L.layerGroup(items.map(item => item.marker)).addTo(map);
    const bounds = L.latLngBounds(items.map(item => item.marker.getLatLng()));
    if (bounds.isValid()) {
      map.fitBounds(bounds.pad(0.15));
    } else {
      map.setView([47.2225, 39.7189], 12);
    }
    $('.leaflet-control-attribution a, .leaflet-control-attribution span').hide();
  }

  const Filters = {
    'filter-all': () => true,
    'filter-open': item => window.mypubs.getBarStatus(item.hours).isOpen,
    'filter-high-rating': item => {
      const value = parseFloat(item.rating.attr('value'));
      return !isNaN(value) && value >= RatingThreshold;
    },
    'filter-recommended': item => item.recommended,
    'filter-average-price': item => !isNaN(item.priceLength) && item.priceLength <= LowPriceLength,
    'filter-beer': item => beer.some(value => item.url.includes(value)),
    'filter-infusions': item => infusions.some(value => item.url.includes(value)),
    'filter-cocktails': item => cocktails.some(value => item.url.includes(value))
  };

  function applyFilter(id) {
    const predicate = Filters[id] || Filters['filter-all'];
    markersGroup.clearLayers();
    const visible = [];
    items.forEach(item => {
      if (predicate(item)) {
        markersGroup.addLayer(item.marker);
        visible.push(item.marker);
      }
    });
    const bounds = L.latLngBounds(visible.map(marker => marker.getLatLng()));
    if (bounds.isValid()) {
      map.fitBounds(bounds.pad(0.15));
    }
  }

  const MapFilterCookie = 'map-filter';

  function setFilters() {
    const buttons = $('#filter-all, #filter-open, #filter-high-rating, #filter-recommended, #filter-average-price, #filter-beer, #filter-infusions, #filter-cocktails');
    buttons.on('click', function(e) {
      e.preventDefault();
      const id = $(this).attr('id');
      buttons.removeClass('is-active');
      $(this).addClass('is-active');
      $('#filter-more-toggle').toggleClass('is-active', $(this).hasClass('filter-dropdown-item'));
      setCookie(MapFilterCookie, id);
      applyFilter(id);
    });

    const saved = getCookie(MapFilterCookie);
    if (saved && buttons.filter(`#${saved}`).length > 0) {
      buttons.filter(`#${saved}`).trigger('click');
    }
  }

  if ($('#map').length > 0) {
    items = collectItems();
    initMap();
    setFilters();
  }

})(jQuery);